import { useQuery, UseQueryResult } from "react-query"
import ResponseError from "../../../utils/ResponseError"
import { RetryConfig } from "../../../utils/ErrorHandling"
import CarrotClient from "../../../lib/carrot-api"
import Settings from "../../../utils/CarrotConfig"
import { CarrotPlanOptions } from "types/CarrotPlanOptions"

const client = new CarrotClient(Settings.CARROT_BACKEND_URL)
const CARROT_PLAN_OPTIONS_QUERY_KEY = "carrotPlanOptions"

async function getCarrotPlanOptions(
  employeeId: number,
  journey?: number,
  journeyStage?: number
): Promise<CarrotPlanOptions> {
  return await client.getCarrotPlanOptions(employeeId, journey, journeyStage)
}

export function useCarrotPlanOptions(
  employeeId: number,
  journey?: number,
  journeyStage?: number
): UseQueryResult<CarrotPlanOptions, ResponseError> {
  return useQuery<CarrotPlanOptions, ResponseError>(
    [CARROT_PLAN_OPTIONS_QUERY_KEY, employeeId, journey, journeyStage],
    () => getCarrotPlanOptions(employeeId, journey, journeyStage),
    {
      ...RetryConfig,
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5
    }
  )
}
